import { ApiRequestPostDataWithDate } from "api/makeApiRequest";
import { makeSubmitData } from "api/makeApiRequestType/makeSubmitData";
import { formatDatesAndTimesForPostRequest } from "api/utils/formatDatesAndTimesForPostRequest";

export type Params<T> = {
	uid: string;
	rows: ({
		old?: T | undefined;
		new?: T | undefined;
	})[];
};

// TODO:WV:20200103:Enforce our API's limit of 50 rows
export const makeSubmitEditableTableChanges = <
	T extends ApiRequestPostDataWithDate
>(
	endPoint: string
) => {
	const preProcessor = (input: ApiRequestPostDataWithDate) => {
		const { rows, ...rest } = input;

		const newRows = (() => {
			if (
				rows &&
				Array.isArray(rows) &&
				rows.every(row => typeof row === "object")
			) {
				return rows.map(row => {
					const { old, new: newRow } = row as Record<string, any>;

					return {
						old: old ? old : undefined,
						new: newRow ? newRow : undefined
					};
				});
			}
		})();

		return formatDatesAndTimesForPostRequest({
			...rest,
			rows: newRows ? newRows : rows
		});
	};

	return makeSubmitData<Params<T>>(endPoint, undefined, preProcessor);
};
